import { defineStore } from 'pinia';
import { formPath } from '@/utils/utils.js';
import router from '@/router';

export const useRouteStore = defineStore('routeStore', {
  state: () => ({
    RoutePath: [],
  }),
  actions: {
    setRoutes(routes) {
      if (!Array.isArray(routes)) {
        console.error('setRoutes: Expected an array, but received:', routes);
        return;
      }

      routes.forEach((route) => {
        if (!router.hasRoute(route.name)) {
          router.addRoute(route);
        }
      });
    },
    setRoutePath(title, headers) {
      const path = formPath(headers, title);
      this.RoutePath = path;
    },
  },
});